import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=5b18d720"
import script from "./topmenu.vue?vue&type=script&lang=js"
export * from "./topmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports